var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenupageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17V9C17 7.114 17 6.171 16.414 5.586C15.828 5 14.886 5 13 5H1V17C1 18.885 1 19.828 1.586 20.414C2.172 21 3.114 21 5 21H13C14.886 21 15.828 21 16.414 20.414C17 19.828 17 18.885 17 17Z",
    stroke: "#E2E2E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.99983C9.79565 9.99983 10.5587 10.3159 11.1213 10.8785C11.6839 11.4411 12 12.2042 12 12.9998M9 9.99983C8.20435 9.99983 7.44129 10.3159 6.87868 10.8785C6.31607 11.4411 6 12.2042 6 12.9998M9 9.99983V8.99983M12 12.9998H6M12 12.9998H13M6 12.9998H5M5 16.9998H13M1 4.99983L8.385 1.90583C10.034 1.21483 10.858 0.868829 11.515 1.04583C11.941 1.1603 12.3172 1.41238 12.585 1.76283C13 2.30483 13 3.20283 13 4.99983",
    stroke: "#E2E2E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenupageDark);
export default __webpack_public_path__ + "static/media/menupage-dark.53212de5d95f48315def2053ae411318.svg";
export { ForwardRef as ReactComponent };